import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SessionService } from '../../core/session.service';
import { I18nService } from '../../core/i18n.service';

@Component({ selector: 'app-login', standalone: true, imports: [FormsModule, RouterLink], templateUrl: './login.html', styleUrl: './login.scss' })
export class Login {
  username = '';
  password = '';
  mfaCode = '';
  showPassword = false;
  isSubmitting = false;

  constructor(public session: SessionService, public i18n: I18nService, private router: Router, private route: ActivatedRoute) {
    this.showOAuthErrorFromQuery();
  }

  async submit(): Promise<void> {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    try {
      const loginSucceeded = this.session.pendingMfaChallenge()
        ? await this.session.completeSoftwareMfaLogin(this.mfaCode)
        : await this.session.login(this.username, this.password);

      if (loginSucceeded) {
        const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/';
        this.router.navigateByUrl(redirectTo);
      }
    } finally {
      this.isSubmitting = false;
    }
  }

  async loginWithGoogle(): Promise<void> {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/dashboard';
    await this.session.loginWithGoogle(redirectTo);
    this.isSubmitting = false;
  }

  async loginWithFacebook(): Promise<void> {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/dashboard';
    await this.session.loginWithFacebook(redirectTo);
    this.isSubmitting = false;
  }

  async loginWithAmazon(): Promise<void> {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/dashboard';
    await this.session.loginWithAmazon(redirectTo);
    this.isSubmitting = false;
  }

  async loginWithApple(): Promise<void> {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/dashboard';
    await this.session.loginWithApple(redirectTo);
    this.isSubmitting = false;
  }

  async loginWithMicrosoft(): Promise<void> {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/dashboard';
    await this.session.loginWithMicrosoft(redirectTo);
    this.isSubmitting = false;
  }

  get isOrcidEnabled(): boolean { return this.session.isOrcidEnabled(); }

  async loginWithOrcid(): Promise<void> {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/dashboard';
    await this.session.loginWithOrcid(redirectTo);
    this.isSubmitting = false;
  }

  async loginWithLinkedIn(): Promise<void> {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/dashboard';
    await this.session.loginWithLinkedIn(redirectTo);
    this.isSubmitting = false;
  }

  async loginWithX(): Promise<void> {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    try {
      const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '/dashboard';
      await this.session.loginWithX(redirectTo);
    } finally {
      this.isSubmitting = false;
    }
  }

  togglePasswordVisibility(): void { this.showPassword = !this.showPassword; }

  private showOAuthErrorFromQuery(): void {
    const query = this.route.snapshot.queryParamMap;
    const error = query.get('oauthError') || query.get('error');
    if (!error) return;
    this.session.showLoginError(query.get('oauthErrorMessage') || query.get('error_message') || query.get('error_description') || error);
  }
}
